angular.module('dpw.directives')
    .directive('dpwToast', ['$timeout', function ($timeout) {
        return {
            restrict: 'A',
            bindToController: true,
            controller: ['$scope', function ($scope) {
                var self = this;
                var config = $scope.config;
                self.content = config.content;
                $timeout(function () {
                    config.close();
                }, config.disappearTime || 2000);
            }],
            controllerAs: 'ctrl',
            templateUrl: 'dpw-toast.html'
        };
    }]);
